import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MemoryService } from './services/memory.service';

@Injectable({
    providedIn: 'root',
})
export class ViewSelectGuard {
    constructor(
        private memoryService: MemoryService,
        private router: Router
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const organizationIsSelect = this.memoryService.isViewSelected();

        return organizationIsSelect;
    }
}
